//bao migrate skip
// bao migrate - module not found: import Params from "components/email-picker/params";
import "./../../bindings/bao-auto-complete";
import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
import BaoUtils from "./../../services/bao-utils";
import BaoSearchDialog from "./../../factories/bao-search-dialog";
export class EMailPickerComponent {
    private _subs: KnockoutSubscription[] = [];
    private _parentElement: HTMLElement;
    public inputValue: KnockoutObservable<string> = ko.observable("");
    private BadgeItems = ko.observableArray<Components.EMailPicker.EMailItem>([]);
    /** same as BadgeItems, but includes the current text-input, if its a valid e-mail
     */
    public EMailItems = ko.observableArray<string>([]);
    public EMailAddressesJoined = ko.observable<string>();
    public IsAMandatoryField = ko.observable<boolean>(false);
    private BadgeText = "EMailAdress";
    private BaoSearchDialogSearchKey = 'Bao-UserEmail';
    private CustomFilterForSearchAsHashObject = ko.pureComputed<Array<Models.HashObject>>(() => {
        return BaoUtils.ObjectToHashObjectArray(this.CustomFilterForSearch());
    });
    private CustomFilterForSearch = ko.observable<{}>({ "SearchEMailAddress": true });
    private AutoCompleteBindingSettings = {
        // url to call for searching
        url: "Search/SearchAutoCompleteSimple",
        // url params to send
        data: {
            customFilter: <KnockoutObservableArray<Models.HashObject> | KnockoutComputed<Array<Models.HashObject>>>this.CustomFilterForSearchAsHashObject,
            pageIndex: 0,
            pageSize: 10,
            searchKey: "Bao-UserEmail",
            propertyName: "Email",
            searchString: "SearchText",
            sorting: [{ Column: 'Email', Direction: 'Ascending' }]
        },
        // data's property to fill search-text
        requestProperty: "searchString"
    };
    Initialized = ko.observable(false);
    constructor(params: Components.EMailPicker.Params, componentElement: HTMLElement) {
        this.inputValue.extend({ rateLimit: 50 });
        this._subs.push(this.inputValue.subscribe((newVal) => { this.txtInput_Changed(newVal); }));
        this.setParams(params);
    }
    private setParams(params: Components.EMailPicker.Params) {
        if (typeof params === "undefined" || params === null) {
            return;
        }
        if (ko.isObservable(params.Items)) {
            if (params.Items() === null || typeof params.Items === "undefined") {
                params.Items([]);
            }
            if (!(typeof params.Items["remove"] === "function" && typeof params.Items["push"] === "function")) {
                params.Items = ko.observableArray(params.Items());
            }
            this.EMailItems = params.Items;
            //load Items
            for (var item in this.EMailItems()) {
                this.insertNewMailItem(this.EMailItems()[item]);
            }
        }
        if (ko.isObservable(params.EMailAddressesJoined)) {
            this._subs.push(this.EMailItems.subscribe((newVal) => {
                params.EMailAddressesJoined(newVal.join(","));
            }));
            params.EMailAddressesJoined(this.EMailItems().join(","));
        }
        if (ko.isObservable(params.IsMandatoryField)) {
            //setzen von IsMandatory 
            this.IsAMandatoryField(params.IsMandatoryField());
        }
        if (ko.unwrap(params.AlternativeSearchObjectKey) && typeof params.AlternativeSearchObjectKey !== "undefined" && typeof ko.unwrap(params.AlternativeSearchObjectKey) !== "undefined") {
            this.AutoCompleteBindingSettings.data.searchKey = ko.unwrap(params.AlternativeSearchObjectKey);
            this.BaoSearchDialogSearchKey = ko.unwrap(params.AlternativeSearchObjectKey);
        }
        if (ko.isObservable(params.CustomFilter)) {
            if (!ko.unwrap(params.CustomFilter) || ko.unwrap(params.CustomFilter) === null || typeof ko.unwrap(params.CustomFilter) === "undefined") {
                params.CustomFilter([]);
            }
            this.CustomFilterForSearch = params.CustomFilter;
            this.AutoCompleteBindingSettings.data.customFilter = params.CustomFilter;
        }
    }
    /**
     *
     */
    txtInput_Changed(val: string) {
        if (val.length < 4)
            return;
        // get valid mail adresses
        let mailAdresses = this.checkAndGetStringsContainingMail(val);
        if (mailAdresses.length > 0) {
            // if entry is seperated with a delmiter char (for example: "my@email.de ")
            if (this.lastCharIsDelimiter(val)) {
                mailAdresses.forEach((mailAdresse) => {
                    this.insertNewMailItem(<string>mailAdresse);
                });
                this.inputValue("");
                this.EMailItems(this.BadgeItems().map((x) => { return x.EMailAdress; }));
            }
            else {
                if (mailAdresses.length > 1) {
                    for (let i = 0; i < mailAdresses.length - 1; i++) {
                        this.insertNewMailItem(<string>mailAdresses[i]);
                    }
                }
                this.inputValue(this.removeAnythingUntilLastDelimiter(val));
                this.EMailItems(this.BadgeItems().map((x) => { return x.EMailAdress; }));
                // manually push last item to e-mailitems, because it is not in the badges
                this.EMailItems.push(mailAdresses[mailAdresses.length - 1]);
            }
            return;
        }
    }
    public lastCharIsDelimiter(str: string) {
        let lastChar = str[str.length - 1];
        let regexDelimiter = /[,;\s]/;
        return regexDelimiter.test(lastChar);
    }
    public checkAndGetStringsContainingMail(str: string): Array<string> {
        let regexDelimiter = /[,;\s<>]/;
        let valTrimmed = str.split(regexDelimiter);
        let emails = [];
        let regexEMailAddress = /\b([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})\b/;
        valTrimmed.forEach((item) => {
            if (regexEMailAddress.test(item)) {
                emails.push(item);
            }
        });
        return emails;
    }
    public removeAnythingUntilLastDelimiter(str: string) {
        let regex = /^.*[,;\s]+/;
        return str.replace(regex, "");
    }
    insertNewMailItem(val: string) {
        // check e-mail is unique
        if (this.checkEMailContainsAlready(val)) {
            return;
        }
        // add unique e-mail
        this.BadgeItems.push({
            BadgeText: val,
            EMailAdress: val,
            PrimaryKeyValue: null
        });
    }
    /**
     * check e-mail is unique
     * @param email
     */
    checkEMailContainsAlready(email: string) {
        let foundItems = this.BadgeItems().filter(item => item.EMailAdress === email);
        return Boolean(foundItems.length > 0);
    }
    /**
     * Event Handler - badge item removed
     */
    BadgeItemRemoved = (item: {
        EMailAdress: string;
    }) => {
        this.EMailItems.remove(item.EMailAdress);
    };
    openBaoSearchDialog() {
        let dia = new BaoSearchDialog();
        dia.InitSearcher({
            // callback when dialog is closed with OK-BTN (only in MultiSelect = false)
            ApplyItemCallback: (selectedModel) => {
                if (ko.unwrap(selectedModel.SelectedItem)) {
                    this.txtInput_Changed(ko.unwrap(selectedModel.SelectedItem).Email + ", ");
                }
            },
            SearchType: "Bao-UserEmail",
            ObjectId: ko.observable<string>(),
            ObjectValue: "Email",
            CustomFilter: this.CustomFilterForSearch()[0],
            MultiSelect: false
        });
    }
    /**
     * Is called by knockout when component is destroyed to cleanup things
     */
    dispose() {
        this._subs.forEach((s) => {
            s.dispose();
        });
    }
}